import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { Identity, IdentityState, IdentityTypes } from './types';

const INITIAL_STATE: IdentityState = {
    data: {} as Identity,
    loading: false,
    hasError: false,
    success: false,
};

const reducer: Reducer<IdentityState> = (state: IdentityState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case 'persist/REHYDRATE':
            if (action.payload && action.payload.identity) {
                return { ...state, ...action.payload.identity, loading: false };
            }
            return { ...state, loading: false };
        case IdentityTypes.AUTH_REQUEST:
            return { ...INITIAL_STATE, loading: true };
        case IdentityTypes.AUTH_SUCCESS:
            return {
                ...INITIAL_STATE,
                data: { ...action.payload.data },
            };
        case IdentityTypes.AUTH_FAILURE:
            return { ...INITIAL_STATE, hasError: true, error: { ...action.payload } };
        case IdentityTypes.ACCEPT_TERMS_SUCCESS:
            return { ...state, data: { ...state.data, person: { ...state.data.person, termsAccepted: true } } };
        case IdentityTypes.ACCEPT_TERMS_FAILURE:
            return {
                ...state,
                hasError: true,
                error: { ...action.payload },
                data: { ...state.data, person: { ...state.data.person, termsAccepted: false } },
            };
        case IdentityTypes.AUTH_FAILURE_CLEAR:
        case IdentityTypes.FORGOT_PASSWORD_FAILURE_CLEAR:
            return { ...state, forgotPasswordMode: false, hasError: false, error: undefined };
        case IdentityTypes.FORGOT_PASSWORD_REQUEST:
            return { ...INITIAL_STATE, forgotPasswordMode: true, loading: true };
        case IdentityTypes.FORGOT_PASSWORD_SUCCESS:
            return { ...state, loading: false };
        case IdentityTypes.FORGOT_PASSWORD_FAILURE:
            return { ...state, loading: false, hasError: true, error: { ...action.payload } };
        case IdentityTypes.CHANGE_PASSWORD_REQUEST:
            return { ...state, loading: true, hasError: false };
        case IdentityTypes.CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    user: {
                        ...state.data.user,
                        mustChangePassword: false,
                    },
                },
                loading: false,
                success: true,
                hasError: false,
            };
        case IdentityTypes.CHANGE_PASSWORD_FAILURE:
            return { ...state, loading: false, success: false, hasError: true, error: { ...action.payload } };
        case IdentityTypes.CHANGE_PASSWORD_CLEAR:
            return { ...state, hasError: false, error: undefined, success: false };
        case IdentityTypes.AUTH_CLEAR:
            return INITIAL_STATE;
        case IdentityTypes.SET_PERSON_DYNAMIC_ATTRIBUTES:
            return { ...state, data: { ...state.data, person: { ...state.data.person, dynamicAttributes: { ...action.payload } } } };
        case IdentityTypes.UPDATE_PERSON_LOCALE:
            return { ...state, data: { ...state.data, person: { ...state.data.person, locale: action.payload } } };
        case IdentityTypes.UPDATE_PERSON_ONBOARDED:
            return { ...state, data: { ...state.data, person: { ...state.data.person, onboarded: action.payload } } };
        case IdentityTypes.UPDATE_PERSON_ACHIEVEMENTS_INFO:
            return { ...state, data: { ...state.data, person: { ...state.data.person, achievementsInfoRead: action.payload } } };
        case IdentityTypes.AUTH_INTEGRATION_REQUEST:
            return { ...INITIAL_STATE, loading: true };
        case IdentityTypes.AUTH_INTEGRATION_SUCCESS:
            return { ...INITIAL_STATE, data: { ...action.payload.data } };
        case IdentityTypes.AUTH_INTEGRATION_FAILURE:
            return { ...INITIAL_STATE, hasError: true, error: { ...action.payload } };
        case IdentityTypes.UPDATE_MY_PERSON:
            return { ...state, data: { ...state.data, person: { ...state.data.person, ...action.payload } } };
        case IdentityTypes.AUTH_SAML_REQUEST:
            return { ...state, loading: true };
        default:
            return state;
    }
};

export default reducer;
